var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"CWCB-Application"}},[_c('Navbar'),_c('v-main',{attrs:{"id":"main"}},[_c('router-view'),_vm._v(" "),_c('Disclaimer',{model:{value:(_vm.disclaimer),callback:function ($$v) {_vm.disclaimer=$$v},expression:"disclaimer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }